module.exports = __webpack_public_path__ + "src/assets/img/intranet.1d891ead.jpg";